import { render } from "./PaymentPage.vue?vue&type=template&id=3c143b68&ts=true"
import script from "./PaymentPage.vue?vue&type=script&lang=ts"
export * from "./PaymentPage.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__